import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://f8b8f89ada5480b91535f1b4afab1f53@o380303.ingest.us.sentry.io/4509142578364416",
});

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
